import React, { useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({
    type: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);

    setStatus({
      type: "",
      message: "",
    });

    try {
      const response = await fetch("/api/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      // Read the response as text first so an empty/non-JSON
      // response doesn't cause "Unexpected end of JSON input".
      const responseText = await response.text();

      let data = {};

      try {
        data = responseText ? JSON.parse(responseText) : {};
      } catch (parseError) {
        console.error("Invalid server response:", responseText);

        throw new Error(
          "The server returned an invalid response. Please try again later."
        );
      }

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to send your message."
        );
      }

      setStatus({
        type: "success",
        message:
          data.message ||
          "Your message has been sent successfully. We will get back to you soon.",
      });

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Contact form error:", error);

      setStatus({
        type: "error",
        message:
          error.message ||
          "Something went wrong. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />

      <section id="contact">
        <div className="container text-center">
          <form
            id="contact-form"
            onSubmit={handleSubmit}
          >
            <h2 id="title" className="mt-5">
              LEAVE A COMMENT
            </h2>

            <div className="row text-left">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="usr">
                    Full Name:
                  </label>

                  <input
                    name="name"
                    type="text"
                    className="form-control"
                    id="usr"
                    value={formData.name}
                    onChange={handleChange}
                    maxLength={100}
                    autoComplete="name"
                    required
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="pwd">
                    Email:
                  </label>

                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    id="pwd"
                    value={formData.email}
                    onChange={handleChange}
                    maxLength={254}
                    autoComplete="email"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="row text-left">
              <div className="col">
                <div className="form-group">
                  <label htmlFor="comment">
                    Comment:
                  </label>

                  <textarea
                    name="message"
                    className="form-control"
                    rows="10"
                    id="comment"
                    value={formData.message}
                    onChange={handleChange}
                    maxLength={5000}
                    required
                  />
                </div>
              </div>
            </div>

            <button
              type="submit"
              className="button-class"
              disabled={loading}
            >
              <b>
                {loading
                  ? "SENDING..."
                  : "SEND MESSAGE"}
              </b>
            </button>

            {status.message && (
              <p
                role="status"
                aria-live="polite"
                style={{
                  marginTop: "20px",
                  fontWeight: "600",
                  color:
                    status.type === "success"
                      ? "#1681c5"
                      : "#d32f2f",
                }}
              >
                {status.message}
              </p>
            )}
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;